module.exports = __webpack_public_path__ + "static/media/b-social-fb.f6aa4bcc.png";